import { StyleSheet } from '@react-pdf/renderer';
import { pdfColors } from './pdfColors';

const iaqInsight2PdfStyles = StyleSheet.create({
    page: {
        paddingTop: '6vw',
        paddingRight: '5vw',
        paddingBottom: '75',
        paddingLeft: '5vw',
        fontFamily: 'Regular',
    },
    headerTitleRow: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        marginBottom: '32',
    },
    headerLogoContainer: {
        width: '86',
        height: '65',
        marginLeft: '20',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    headerLogo: {
        maxWidth: '86',
        maxHeight: '65',
        objectFit: 'contain',
    },
    headerText: {
        fontSize: 25,
        fontFamily: 'DemiBold',
        maxWidth: '60vw',
    },
    headerBlock: {
        marginBottom: '3vw',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
    },
    reportTitle: {
        fontSize: 18,
        fontFamily: 'DemiBold',
        color: pdfColors.blackShark,
        marginBottom: 0,
        lineHeight: 1.2,
        paddingTop: '43',
    },
    introParagraph: {
        fontSize: '11',
        fontFamily: 'Light',
        color: pdfColors.blackShark,
        lineHeight: 1.5,
        marginBottom: '32',
    },
    buildingName: {
        fontSize: 16,
        fontFamily: 'DemiBold',
        marginBottom: '0.5vw',
        color: pdfColors.blackShark,
    },
    buildingAddress: {
        fontSize: 10,
        fontFamily: 'Regular',
        color: pdfColors.blackShark,
        marginBottom: '16',
        lineHeight: 1.2,
    },
    sectionTitle: {
        fontSize: 16,
        fontFamily: 'DemiBold',
        marginTop: '4.5vw',
        marginBottom: '24',
        color: pdfColors.blackShark,
        lineHeight: 1.2,
    },
    airQualityAveragesDescription: {
        fontSize: '11',
        fontFamily: 'Light',
        color: pdfColors.blackShark,
        lineHeight: 1.5,
        marginBottom: '32',
    },
    logoContainer: {
        height: '12vw',
        display: 'flex',
        marginTop: '-5px',
        marginRight: '4vw',
        width: '30vw',
        justifyContent: 'flex-start',
    },
    paragraph: {
        fontSize: 11,
        fontFamily: 'Light',
        marginTop: '0',
        marginBottom: '32',
        color: pdfColors.blackShark,
        lineHeight: 1.5,
    },
    subHeader: {
        fontSize: '12',
        fontFamily: 'DemiBold',
        marginTop: '32',
        marginBottom: '2vw',
    },
    subHeaderNoMargin: {
        fontSize: '13',
    },
    boldText: {
        fontFamily: 'DemiBold',
    },
    smallText: {
        fontSize: 10,
        wordWrap: 'break-word',
        wordBreak: 'break-word',
        whiteSpace: 'pre-wrap',
        maxWidth: '80%',
        textAlign: 'left',
    },
    colorRed: {
        backgroundColor: pdfColors.redPersian,
    },
    colorGreen: {
        backgroundColor: pdfColors.greenBiosphere,
    },
    colorYellow: {
        backgroundColor: pdfColors.yellowSunlight,
    },
    textColorRed: {
        color: pdfColors.redPersian,
    },
    textColorGreen: {
        color: pdfColors.greenBiosphere,
    },
    coloredCircle: {
        minWidth: '10',
        height: '50',
        width: '50',
        marginTop: '2',
        border: '5 solid gray',
        borderRadius: '25',
        position: 'relative',
    },
    coloredCircleRed: {
        borderColor: pdfColors.redPersian,
    },
    coloredCircleGreen: {
        borderColor: pdfColors.greenBiosphere,
    },
    coloredCircleYellow: {
        borderColor: pdfColors.yellowSunlight,
    },
    coloredCircleGrey: {
        borderColor: pdfColors.greyMist,
    },
    smallCircle: {
        height: '28px',
        width: '28px',
        borderWidth: 3.5,
        marginRight: '5px',
    },
    coloredDot: {
        minWidth: '10',
        height: '10',
        width: '10',
        marginTop: '2',
        marginLeft: '8',
        marginRight: '9',
        borderRadius: '9',
    },
    flexWrapper: {
        display: 'flex',
        flexDirection: 'row',
    },
    flexWrapperSpaced: {
        display: 'flex',
        flexDirection: 'row',
        fontSize: '10',
        justifyContent: 'space-between',
    },
    flexWrapperWrapped: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
    },
    insightWrapper: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
    },
    pageLine: {
        borderTop: `0.5 solid ${pdfColors.greyMist}`,
        marginTop: '2vw',
        marginBottom: '2vw',
    },
    footer: {
        width: '100%',
        position: 'absolute',
        bottom: '30',
        left: '0',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        margin: '0 30',
        alignItems: 'baseline',
    },
    smallLogo: {
        width: '10vw',
        height: '8vw',
    },
    pageNumbers: {
        bottom: 20,
        left: 0,
        right: 0,
        textAlign: 'center',
    },
    tableContainer: {
        marginTop: '1.5vw',
        width: '100%',
    },
    tableRow: {
        flexDirection: 'row',
        borderBottom: `1 solid ${pdfColors.greyPorcelain}`,
        minHeight: '32',
    },
    tableHeaderRow: {
        flexDirection: 'row',
        borderBottom: `1 solid ${pdfColors.greyPorcelain}`,
        backgroundColor: pdfColors.greyLightBg,
        minHeight: '32',
    },
    tableHeaderCell: {
        padding: '8 12',
        backgroundColor: pdfColors.greyLightBg,
        minHeight: '32',
        display: 'flex',
        justifyContent: 'center',
    },
    tableHeaderText: {
        fontSize: '9',
        fontFamily: 'Regular',
        color: pdfColors.blackShark,
        lineHeight: 1.4,
    },
    tableCell: {
        padding: '8 12',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        minHeight: '32',
    },
    tableCellText: {
        fontSize: '10',
        fontFamily: 'Regular',
        color: pdfColors.blackShark,
        lineHeight: 1.5,
    },
    tableCellUnit: {
        fontSize: '8',
        fontFamily: 'Light',
        color: pdfColors.blackShark,
        lineHeight: 1.5,
    },
    spaceNameText: {
        fontSize: '10',
        fontFamily: 'Regular',
        color: pdfColors.blackShark,
        lineHeight: 1.4,
        marginBottom: '2',
    },
    ratingText: {
        fontSize: '7.83',
        fontFamily: 'DemiBold',
        marginTop: '0',
        lineHeight: 1.4,
    },
    headerCell: {
        padding: '5',
    },
    firstColumn: {
        width: '33%',
    },
    valueColumn: {
        width: '22.33%',
    },
    deviceIcon: {
        width: '34',
        height: '34',
        padding: '5',
        marginTop: '3',
        marginLeft: '3',
    },
    sensorValue: {
        fontSize: '18',
        fontFamily: 'DemiBold',
    },
    sensorValueWrapper: {
        fontSize: '10',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'baseline',
    },
    sensorUnitText: {
        fontSize: '7',
        paddingBottom: '3',
    },
    paddedAverage: {
        margin: '5 0',
    },
    valueWrapper: {
        paddingLeft: '2vw',
        paddingRight: '2vw',
    },
    paddedValueWrapper: {
        marginLeft: '50',
        paddingLeft: '2vw',
        paddingRight: '2vw',
    },
    viewSize: {
        width: '52vw',
    },
    sensorHeader: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        marginTop: '2vw',
        marginBottom: '24',
        flexWrap: 'wrap',
    },
    sensorTitle: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: '8',
    },
    sensorName: {
        fontSize: '20',
        fontFamily: 'DemiBold',
        color: pdfColors.blackShark,
    },
    ratingLegend: {
        display: 'flex',
        flexDirection: 'row',
        gap: '4',
        flexWrap: 'nowrap',
        alignItems: 'flex-start',
    },
    legendItem: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '2',
        minWidth: '65',
        flex: '0 0 auto',
    },
    thresholdPill: {
        paddingTop: '1.5',
        paddingBottom: '5',
        paddingLeft: '6',
        paddingRight: '6',
        borderRadius: '8',
        minWidth: '30',
        width: 'auto',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    pillText: {
        fontSize: '9',
        fontFamily: 'DemiBold',
        lineHeight: 1,
        textAlign: 'center',
    },
    legendRange: {
        fontSize: '8',
        textAlign: 'center',
        color: pdfColors.greyLegendText,
        marginTop: '2',
        lineHeight: 1.3,
        fontFamily: 'Regular',
    },
    description: {
        fontSize: 11,
        fontFamily: 'Light',
        marginTop: '0',
        marginBottom: '32',
        color: pdfColors.blackShark,
        lineHeight: 1.5,
    },
    summaryCardsGrid: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        gap: '16',
        marginBottom: '16',
    },
    summaryCard: {
        width: '48%',
        padding: '9.57',
        border: `0.6 solid ${pdfColors.greyMist}`,
        borderRadius: '5.98',
        backgroundColor: pdfColors.white,
        minHeight: '55',
    },
    summaryCardTitle: {
        fontSize: '10',
        fontFamily: 'Regular',
        marginBottom: '6',
        color: pdfColors.blackShark,
        lineHeight: 1.4,
    },
    summaryCardValue: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'baseline',
        gap: '4',
        marginBottom: '4',
    },
    summaryValue: {
        fontSize: '14',
        fontFamily: 'DemiBold',
        color: pdfColors.blackShark,
        lineHeight: 1.2,
    },
    summaryUnit: {
        fontSize: '10',
        color: pdfColors.blackShark,
        lineHeight: 1.2,
    },
    summaryRating: {
        fontSize: '10',
        fontFamily: 'DemiBold',
        marginTop: '2',
        lineHeight: 1.2,
    },
    detailCard: {
        width: '48%',
        padding: '9.57',
        border: `0.6 solid ${pdfColors.greyMist}`,
        borderRadius: '5.98',
        backgroundColor: pdfColors.white,
        minHeight: '55',
    },
    detailCardHeader: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: '8',
        marginBottom: '8',
    },
    detailCount: {
        fontSize: '10',
        fontFamily: 'Regular',
        color: pdfColors.blackShark,
        lineHeight: 1.4,
    },
    detailCountNumber: {
        fontSize: '14',
        fontFamily: 'DemiBold',
        color: pdfColors.blackShark,
        lineHeight: 1.2,
    },
    detailLabel: {
        fontSize: '10',
        fontFamily: 'Regular',
        color: pdfColors.blackShark,
        marginBottom: '4',
        lineHeight: 1.4,
    },
    detailPeakRange: {
        fontSize: '10',
        fontFamily: 'Regular',
        color: pdfColors.blackShark,
        lineHeight: 1.4,
    },
    graphDescription: {
        fontSize: 11,
        fontFamily: 'Light',
        color: pdfColors.blackShark,
        marginTop: '8',
        marginBottom: '1',
        lineHeight: 1.5,
    },
    chartContainer: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        marginTop: '0',
        marginBottom: '24',
    },
    chartImage: {
        width: '100%',
        height: '180',
        objectFit: 'contain',
    },
    topSummaryCardsGrid: {
        display: 'flex',
        flexDirection: 'column',
        marginBottom: '32',
        width: '100%',
    },
    summaryCardsRow: {
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        marginBottom: '18',
    },
    sensorSummaryItem: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        flex: '1 1 0%',
        marginRight: '2%',
    },
    sensorSummaryContent: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        marginLeft: '6',
        flex: 1,
        minWidth: 0,
    },
    sensorSummaryHeader: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: '5',
        marginBottom: '0',
        flexWrap: 'nowrap',
        minWidth: 0,
        flexShrink: 1,
    },
    sensorSummaryName: {
        fontSize: '11',
        fontFamily: 'Light',
        color: pdfColors.blackShark,
        flexShrink: 1,
        minWidth: 0,
    },
    statusPill: {
        paddingTop: '1.5',
        paddingBottom: '5',
        paddingLeft: '6',
        paddingRight: '6',
        borderRadius: '12',
        minWidth: '30',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    statusPillText: {
        fontSize: '9',
        fontFamily: 'DemiBold',
        lineHeight: 1,
        textAlign: 'center',
    },
    sensorSummaryValue: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: '4',
    },
    sensorSummaryValueText: {
        fontSize: '14.45',
        fontFamily: 'DemiBold',
        color: pdfColors.blackShark,
        lineHeight: 1.2,
    },
    sensorSummaryUnit: {
        fontSize: '9',
        fontFamily: 'Light',
        color: pdfColors.blackShark,
        lineHeight: 1.2,
    },
    metricCardIcon: {
        width: '18',
        height: '18',
        objectFit: 'contain',
    },
    metricCardName: {
        fontSize: '11',
        fontFamily: 'Regular',
        color: pdfColors.blackShark,
    },
    metricCardValue: {
        fontSize: '17',
        fontFamily: 'DemiBold',
        color: pdfColors.blackShark,
        lineHeight: 1.2,
    },
    metricCardUnit: {
        fontSize: '10',
        fontFamily: 'Regular',
        color: pdfColors.blackShark,
        lineHeight: 1.2,
    },
    co2LegendContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        marginTop: '48',
        marginBottom: '32',
    },
    co2LegendHeader: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: '8',
        marginBottom: '16',
    },
    co2LegendLabel: {
        fontSize: '14',
        fontFamily: 'Regular',
        color: pdfColors.blackShark,
    },
    co2LegendItems: {
        display: 'flex',
        flexDirection: 'row',
        gap: '16',
        flexWrap: 'nowrap',
        alignItems: 'flex-start',
    },
    co2LegendItem: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '4',
        minWidth: '80',
        flex: '0 0 auto',
    },
    co2LegendPill: {
        paddingTop: '3',
        paddingBottom: '7',
        paddingLeft: '12',
        paddingRight: '12',
        borderRadius: '16',
        minWidth: '55',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    co2LegendPillText: {
        fontSize: '9',
        fontFamily: 'DemiBold',
        lineHeight: 1,
        textAlign: 'center',
    },
    co2LegendRange: {
        fontSize: '8',
        fontFamily: 'Regular',
        color: pdfColors.greyLegendText,
        textAlign: 'center',
        lineHeight: 1.3,
        marginTop: '4',
    },
    buildingDetailsGrid: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        gap: '9vw',
    },
    buildingDetailItem: {
        display: 'flex',
        flexDirection: 'column',
        gap: '0.5vw',
    },
    openingHoursDayItem: {
        display: 'flex',
        flexDirection: 'column',
        gap: '0.5vw',
    },
    buildingDetailLabel: {
        fontSize: '10',
        fontFamily: 'Regular',
        color: pdfColors.blackShark,
    },
    buildingDetailValue: {
        fontSize: '10',
        fontFamily: 'Light',
        color: pdfColors.blackShark,
    },
    dayLabel: {
        fontSize: '10',
        fontFamily: 'Regular',
        color: pdfColors.blackShark,
    },
    dayValue: {
        fontSize: '10',
        fontFamily: 'Light',
        color: pdfColors.blackShark,
    },
    noDataContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '24',
        marginTop: '16',
        marginBottom: '16',
    },
    noDataText: {
        fontSize: '10',
        fontFamily: 'Light',
        color: pdfColors.greyFooter,
        textAlign: 'center',
    },
});

export default iaqInsight2PdfStyles;
